import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  CreatePOIModel,
  CreatePOIParams,
  GetElementTypesBySettingTypeResponse,
  GetPOIByIdResponse,
  GetSettingTypesByPOIResponse,
  ProblemDetails
} from '../../models';

import { useCustomAppClient } from '../../custom-client.tsx';
import type { ErrorType } from '../../custom-client.tsx';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get POI by id
 */
export const useGetPOIByIdHook = () => {
        const getPOIById = useCustomAppClient<GetPOIByIdResponse>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {


        return getPOIById(
          {url: `/POI/${id}`, method: 'GET', signal
    },
          );
        }, [getPOIById])
      }




export const getGetPOIByIdQueryKey = (id: string,) => {
    return [
    `/POI/${id}`
    ] as const;
    }


export const useGetPOIByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError = ErrorType<ProblemDetails>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPOIByIdQueryKey(id);

  const getPOIById =  useGetPOIByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>> = ({ signal }) => getPOIById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPOIByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>>
export type GetPOIByIdQueryError = ErrorType<ProblemDetails>


export function useGetPOIById<TData = Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPOIById<TData = Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPOIById<TData = Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPOIById<TData = Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError = ErrorType<ProblemDetails>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPOIByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPOIByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create or update POI
 */
export const useCreatePOIHook = () => {
        const createPOI = useCustomAppClient<GetPOIByIdResponse>();

        return useCallback((
    createPOIModel: CreatePOIModel,
    params: CreatePOIParams,
 signal?: AbortSignal
) => {


        return createPOI(
          {url: `/POI`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPOIModel,
        params, signal
    },
          );
        }, [createPOI])
      }




export const getCreatePOIMutationKey = () => ['createPOI'] as const;

export const useCreatePOIMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreatePOIHook>>>, TError,CreatePOIMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreatePOIHook>>>, TError,CreatePOIMutationVariables, TContext> => {

const mutationKey = getCreatePOIMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createPOI =  useCreatePOIHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreatePOIHook>>>, CreatePOIMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  createPOI(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePOIMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreatePOIHook>>>>
    export type CreatePOIMutationBody = CreatePOIModel
    export type CreatePOIMutationError = ErrorType<ProblemDetails>
    export type CreatePOIMutationVariables = {data: CreatePOIModel;params: CreatePOIParams}

    export const useCreatePOI = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreatePOIHook>>>, TError,CreatePOIMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreatePOIHook>>>,
        TError,
        CreatePOIMutationVariables,
        TContext
      > => {
      return useMutation(useCreatePOIMutationOptions(options), queryClient);
    }
    /**
 * Get setting types by POI
 */
export const useGetSettingTypesByPOIHook = () => {
        const getSettingTypesByPOI = useCustomAppClient<GetSettingTypesByPOIResponse>();

        return useCallback((
    poiType: 'PlanarFace' | 'StraightWall',
 signal?: AbortSignal
) => {


        return getSettingTypesByPOI(
          {url: `/POI/settings/${poiType}`, method: 'GET', signal
    },
          );
        }, [getSettingTypesByPOI])
      }




export const getGetSettingTypesByPOIQueryKey = (poiType: 'PlanarFace' | 'StraightWall',) => {
    return [
    `/POI/settings/${poiType}`
    ] as const;
    }


export const useGetSettingTypesByPOIQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError = ErrorType<ProblemDetails>>(poiType: 'PlanarFace' | 'StraightWall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingTypesByPOIQueryKey(poiType);

  const getSettingTypesByPOI =  useGetSettingTypesByPOIHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>> = ({ signal }) => getSettingTypesByPOI(poiType, signal);





   return  { queryKey, queryFn, enabled: poiType !== null && poiType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingTypesByPOIQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>>
export type GetSettingTypesByPOIQueryError = ErrorType<ProblemDetails>


export function useGetSettingTypesByPOI<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError = ErrorType<ProblemDetails>>(
 poiType: 'PlanarFace' | 'StraightWall', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingTypesByPOI<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError = ErrorType<ProblemDetails>>(
 poiType: 'PlanarFace' | 'StraightWall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingTypesByPOI<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError = ErrorType<ProblemDetails>>(
 poiType: 'PlanarFace' | 'StraightWall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSettingTypesByPOI<TData = Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError = ErrorType<ProblemDetails>>(
 poiType: 'PlanarFace' | 'StraightWall', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSettingTypesByPOIHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSettingTypesByPOIQueryOptions(poiType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns an empty list when no element types are assigned.
 * @summary Get element types assigned to a setting type
 */
export const useGetElementTypesBySettingTypeHook = () => {
        const getElementTypesBySettingType = useCustomAppClient<GetElementTypesBySettingTypeResponse>();

        return useCallback((
    settingType?: 'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors',
 signal?: AbortSignal
) => {


        return getElementTypesBySettingType(
          {url: `/POI/settings/${settingType}/elementTypes`, method: 'GET', signal
    },
          );
        }, [getElementTypesBySettingType])
      }




export const getGetElementTypesBySettingTypeQueryKey = (settingType?: 'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors',) => {
    return [
    `/POI/settings/${settingType}/elementTypes`
    ] as const;
    }


export const useGetElementTypesBySettingTypeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError = ErrorType<unknown>>(settingType?: 'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetElementTypesBySettingTypeQueryKey(settingType);

  const getElementTypesBySettingType =  useGetElementTypesBySettingTypeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>> = ({ signal }) => getElementTypesBySettingType(settingType, signal);





   return  { queryKey, queryFn, enabled: settingType !== null && settingType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetElementTypesBySettingTypeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>>
export type GetElementTypesBySettingTypeQueryError = ErrorType<unknown>


export function useGetElementTypesBySettingType<TData = Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError = ErrorType<unknown>>(
 settingType: undefined |  'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetElementTypesBySettingType<TData = Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError = ErrorType<unknown>>(
 settingType?: 'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetElementTypesBySettingType<TData = Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError = ErrorType<unknown>>(
 settingType?: 'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get element types assigned to a setting type
 */

export function useGetElementTypesBySettingType<TData = Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError = ErrorType<unknown>>(
 settingType?: 'Panels' | 'Connectors' | 'Corners' | 'StopEnd' | 'Anchors', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetElementTypesBySettingTypeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetElementTypesBySettingTypeQueryOptions(settingType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}





